import React from 'react';
import useBgColorStore from '../../store/bgColor';

interface MaxDetailsProps {
  title: string;
  data: {
    label: string;
    current: number;
    max: number;
  }[];
}

const PdDownHill: React.FC<MaxDetailsProps> = ({ title, data }) => {
  const { bgColor, updateBgColor } = useBgColorStore();
  return (
    <div
      className={`bg-backgroundColor-white border  border-customBorder-border rounded-md p-4 w-full mb-4`}
    >
      <h3 className="text-text-primary font-semibold text-sm mb-2 text-start">
        {title}
      </h3>
      <div className=" mb-2"></div>
      <div className="flex flex-col sm:flex-row sm:justify-between">
        {data.map((data, index) => (
          <div key={index} className="text-center">
            <p className="text-text-primary text-sm">{data.label}</p>
            <p className="font-semibold text-textColor text-base">
              <span className="text-text-primary">{data.current}</span>
              <span className="text-text-primary">/</span>
              <span>{data?.max}</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PdDownHill;
